import { makeStyles, Theme } from '@material-ui/core/styles'

const BORDER = '#e6e9ed'
const SURFACE = '#f6f8fa'
const BRAND = '#008C85'
const BRAND_DARK = '#00736d'

export const useTenantMessageStyles = makeStyles((theme: Theme) => ({
    paper: {
        borderRadius: 16,
        overflow: 'hidden',
        outline: 'none',
        boxShadow:
            '0 24px 48px -12px rgba(0,0,0,0.25), 0 0 0 1px rgba(0,0,0,0.04)',
    },
    header: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1.5),
        padding: theme.spacing(2, 3),
        borderBottom: `1px solid ${BORDER}`,
        backgroundColor: '#fff',
    },
    headerIcon: {
        width: 40,
        height: 40,
        borderRadius: 12,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'rgba(0,140,133,0.12)',
        color: BRAND,
        flexShrink: 0,
    },
    headerTitle: {
        fontWeight: 700,
        fontSize: '1.05rem',
        lineHeight: 1.2,
    },
    headerSubtitle: {
        fontSize: '0.8rem',
        color: theme.palette.text.secondary,
    },
    body: {
        flex: 1,
        minHeight: 0,
        overflowY: 'auto',
        backgroundColor: SURFACE,
        padding: theme.spacing(2.5),
    },
    section: {
        backgroundColor: '#fff',
        border: `1px solid ${BORDER}`,
        borderRadius: 12,
        padding: theme.spacing(2.5),
        marginBottom: theme.spacing(2),
    },
    sectionTitle: {
        fontWeight: 700,
        fontSize: '0.95rem',
        color: theme.palette.text.primary,
        marginBottom: theme.spacing(1.5),
    },
    footer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        gap: theme.spacing(1.5),
        padding: theme.spacing(2, 3),
        borderTop: `1px solid ${BORDER}`,
        backgroundColor: '#fff',
    },
    sendButton: {
        backgroundColor: BRAND,
        color: '#fff',
        textTransform: 'none',
        fontWeight: 600,
        boxShadow: 'none',
        '&:hover': {
            backgroundColor: BRAND_DARK,
            boxShadow: 'none',
        },
    },
    cancelButton: {
        textTransform: 'none',
        fontWeight: 600,
    },
    previewCard: {
        border: `1.5px solid #e6e9ed`,
        borderRadius: 12,
        overflow: 'hidden',
        backgroundColor: '#fff',
    },
    previewHeader: {
        display: 'flex',
        alignItems: 'center',
        padding: theme.spacing(1.5, 2),
        cursor: 'pointer',
        transition: 'background-color 0.1s',
        '&:hover': {
            backgroundColor: '#f9fafb',
        },
    },
    previewBadge: {
        width: 40,
        height: 40,
        borderRadius: 10,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'rgba(0,140,133,0.1)',
        color: BRAND,
        fontWeight: 700,
        fontSize: '1rem',
        flexShrink: 0,
    },
    previewList: {
        borderTop: `1px solid #e6e9ed`,
        backgroundColor: '#f9fafb',
        '& .MuiTableCell-head': {
            backgroundColor: '#f3f4f6',
        },
    },
    tenantChip: {
        margin: theme.spacing(0.25),
    },
    audienceCard: {
        flex: 1,
        display: 'flex',
        alignItems: 'center',
        border: `1.5px solid ${BORDER}`,
        borderRadius: 10,
        padding: theme.spacing(1.5, 1.75),
        cursor: 'pointer',
        transition: 'border-color 0.15s, background-color 0.15s',
        '&:hover': {
            borderColor: '#b0b8c1',
        },
    },
    scopeCard: {
        display: 'flex',
        alignItems: 'center',
        border: `1.5px solid ${BORDER}`,
        borderRadius: 10,
        padding: theme.spacing(1.25, 1.5),
        cursor: 'pointer',
        transition: 'border-color 0.15s, background-color 0.15s',
        '&:hover': {
            borderColor: '#b0b8c1',
        },
    },
}))
